import { WorkstationState } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils/http';

export const getWorkstation = (): Promise<Required<WorkstationState[]>> => HttpClient.get(API_FACTORY.v1('workstations'));

export const updateWorkstation = (workstation: WorkstationState): Promise<Required<WorkstationState>> =>
  HttpClient.put(API_FACTORY.v1('workstations'), workstation);
